const translations = {
    delete: 'Delete',
    edit: 'Edit',
    errorExporting: 'Error Exporting',
    export: 'Export To Excel',
    view: 'View'
};

export default translations;
